/** Copy shared by the tracker's server checks and its page, so both say the same thing. */

export const FUTURE_DATE_MESSAGE = 'That date is in the future. Pick today or an earlier day.';
export const BOOKING_DATE_MESSAGE =
  'Pick the day the conversation happens. It can’t be before the day you booked it.';
export const AMOUNT_BOOKED_MESSAGE = 'Add the amount booked. Use numbers only, like 4800.';
export const AMOUNT_COLLECTED_MESSAGE = 'Add the amount collected. Use numbers only, like 4800.';
export const NUMBERS_ONLY_MESSAGE = 'Use numbers only, like 4800.';
export const FILE_TOO_BIG_MESSAGE =
  'That file is too big to import. Split it and import the rest after.';

/** The next step a booking leaves: the conversation itself, on its day. */
export const CONVERSATION_NEXT_STEP = 'Conversation';
export const BOOK_A_CONVERSATION = 'Book a conversation';
export const RECAP_SENT = 'Recap sent';
export const MESSAGE_LABEL = 'Message';

/** Each sheet CSV, as JSON-encoded UTF-8 bytes; two of them stay under the 2 MiB request limit. */
export const MAX_IMPORT_CSV_BYTES = 1_000_000;
